export default __webpack_public_path__ + "static/media/redExtraSmall.178c97ca.svg";